import { fetchWithFallback } from "../OrgUsageAnalytics/api";

// Mounted at /admin/loa-permissions on the backend. The backend verifies the
// Firebase ID token that fetchWithFallback sends and requires an Addy staff
// email; the userId query param is ignored there.
const BASE = "/loa-permissions";

export async function getLoaPermissions(env, organizationId) {
  return fetchWithFallback(`${BASE}/${encodeURIComponent(organizationId)}`, {}, { env });
}

// body: { enabled?, permissions?, enforceNewChecks? }. `permissions` replaces
// the saved switches as a whole.
export async function saveLoaPermissions(env, organizationId, body) {
  return fetchWithFallback(
    `${BASE}/${encodeURIComponent(organizationId)}`,
    {},
    { env, method: "POST", body },
  );
}
